import { useMemo, useState } from 'react';
import { Alert } from 'rsuite';
import { OfferFormProvider } from '../context';
import { bulkEditOffer } from '../services';
import { computeBulkInitialValues } from '../utils/computeBulkInitialValues';
import { ModalLayout } from './ModalLayout';
import { OfferCreationForm } from './OfferCreationForm';
import type { IRowData } from './OfferTable/OfferTable';
import { useOfferInlineEditStore } from './OfferTable/hooks/useOfferInlineEditStore';

interface ModalBulkEditOfferWrapProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedOffers: IRowData[];
  blocosOfertas: { label: string; value: string | number }[];
  id: string;
  idsLojas: string[];
}

export const ModalBulkEditOfferWrap = ({ show, onClose, onConfirm, selectedOffers, blocosOfertas, id, idsLojas }: ModalBulkEditOfferWrapProps) => {
  const [isFormValid, setIsFormValid] = useState(false);
  const [oferta, setOferta] = useState<any>({ products: [], offer_groups: {}, offer: {} });

  const { initialOffer, initialOfferGroup, initialProducts } = useMemo(() => computeBulkInitialValues(selectedOffers), [selectedOffers]);

  const handleConfirm = async () => {
    const productIds = selectedOffers.map(offer => offer.product_uuid).filter(Boolean);
    const payload = {
      product_ids: productIds,
      offer: oferta.offer,
      ...(oferta.offer_group?.id && { offer_group_id: oferta.offer_group.id }),
    };

    try {
      const resp = await bulkEditOffer(id, payload);
      if (resp?.status >= 200 && resp?.status < 300) {
        useOfferInlineEditStore.getState().removeRows(productIds as string[]);
        onConfirm();
        return;
      }
      Alert.error('Erro ao salvar as ofertas.', 5000);
    } catch {
      Alert.error('Erro ao salvar as ofertas.', 5000);
    }
  };

  return (
    <ModalLayout
      show={show}
      onConfirm={handleConfirm}
      onCancel={onClose}
      title="Editar ofertas em massa"
      confirmButton="Alterar ofertas"
      confirmDisabled={!isFormValid}
      cancelButton="fechar"
      width="900px"
      height="782px"
    >
      <OfferFormProvider key={String(show)}>
        <OfferCreationForm
          id={id}
          idsLojas={idsLojas}
          blocosOfertas={blocosOfertas as any}
          setOferta={setOferta}
          editOferta
          show={show}
          initialProducts={initialProducts as any}
          onValidityChange={setIsFormValid}
          initialOffer={initialOffer}
          initialOfferGroup={initialOfferGroup}
        />
      </OfferFormProvider>
    </ModalLayout>
  );
};
